import { createStore } from "vuex";
import auth from './store/modules/auth';

const store = createStore({
  state: {
    snackbar: {},
    isAuthReady: false,
    authEmail: '',
  },

  mutations: {
    setSnackbar: (state, payload) => {
      state.snackbar = payload;
    },
    setIsAuthReady: (state, val) => {
      state.isAuthReady = val;
    },
    setAuthEmail: (state, email) => {
      state.authEmail = email;
    },
  },

  actions: {},

  modules: {
    auth
  },
});

// Initialize AWS Amplify configuration
import './config/amplify';

// Initialize auth session on store creation
store.dispatch("auth/fetchSession")
  .catch(err => err)
  .finally(() => store.commit("setIsAuthReady", true));

export default store;
